// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.DownloadButton-module__aTag__3tCo6:hover{text-decoration:none}\n", ""]);
// Exports
exports.locals = {
	"aTag": "DownloadButton-module__aTag__3tCo6"
};
module.exports = exports;
